import { Card, Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';

interface Props {
  value: string[];
  onChange: (tags: string[]) => void;
}

/** 標籤編輯（WordPress 風格）：可自由輸入新標籤，也能從既有標籤自動完成挑選。 */
export default function TagsCard({ value, onChange }: Props) {
  const tags = useQuery({ queryKey: ['tags'], queryFn: () => api.tags() });

  return (
    <Card title="標籤">
      <Select
        mode="tags"
        className="w-full"
        allowClear
        placeholder="輸入或選擇標籤，可自由新增（Enter 或逗號分隔）"
        tokenSeparators={[',', '，']}
        value={value}
        onChange={onChange}
        options={(tags.data ?? []).map((t) => ({ value: t.name, label: t.name }))}
      />
    </Card>
  );
}
